function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { Button, Input, Form, InputNumber, Space, Modal, Select, message, Alert, notification } from 'antd';
import { FuelPumpFill } from 'react-bootstrap-icons';
import Common from '../includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AddPumpReport = function AddPumpReport(_ref) {
  var handler = _ref.handler,
    _ref$station = _ref.station,
    station = _ref$station === void 0 ? null : _ref$station;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    agentOptions = _useState8[0],
    setAgentOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    productOptions = _useState10[0],
    setProductOptions = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    productList = _useState12[0],
    setProductList = _useState12[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    if (station == null) notification.error({
      message: "Erreur",
      description: "Aucune station"
    });
    setFormError('');
    setFormSuccess('');
    if (values.indexStart > values.indexEnd) return setFormError("L'index de depart est supérieur à l'index d'arrivé");
    confirm({
      title: 'Confirmez-nous la reception ?',
      content: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "INDEX DE DEPART: "
            }), " ", values.indexStart.toLocaleString('Fr')]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "INDEX D'ARRIVE: "
            }), " ", values.indexEnd.toLocaleString('Fr')]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL VENDU : "
            }), ((values.indexEnd - values.indexStart) * productList.filter(function (p) {
              return p.id == values.product_id;
            })[0].base_price).toLocaleString('Fr'), " GNF"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL CASH DEPOSE : "
            }), " ", values.total_cash.toLocaleString('Fr'), " GNF"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL BONS DEPOSE : "
            }), " ", values.total_coupon.toLocaleString('Fr'), " GNF"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL DEPOSE (CASH + BONS) : "
            }), " ", (values.total_cash + values.total_coupon).toLocaleString('Fr'), " GNF"]
          }), values.total_cash + values.total_coupon < (values.indexEnd - values.indexStart) * productList.filter(function (p) {
            return p.id == values.product_id;
          })[0].base_price && /*#__PURE__*/_jsxs("li", {
            style: {
              color: '#E35858'
            },
            children: [/*#__PURE__*/_jsx("b", {
              children: "ECART :"
            }), " ", (values.total_cash + values.total_coupon - (values.indexEnd - values.indexStart) * productList.filter(function (p) {
              return p.id == values.product_id;
            })[0].base_price).toLocaleString('Fr'), " GNF"]
          })]
        })]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'addpumpreport', {
          indexStart: values.indexStart,
          indexEnd: values.indexEnd,
          user_id: Common.currentUser.id,
          agent_id: values.agent_id,
          total_cash: values.total_cash,
          total_coupon: values.total_coupon,
          product_id: values.product_id,
          station_id: station.id
        }).then(function (response) {
          if (response.data.status == 200) {
            handler();
          } else {
            setFormError(response.data.message);
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue ' + error.toString(),
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    if (station == null) return;
    axios.all([axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        response[0].data.users.filter(function (u) {
          return u.role == 401;
        }).forEach(function (u) {
          setAgentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id,
              gas_station_id: u.gas_station_id
            }]);
          });
        });
      }
      var ur = response[0].data.users.filter(function (u) {
        return u.role == 401;
      });
      if (ur.length > 0) {
        form.setFieldsValue({
          agent_id: ur[0].id
        });
        setProductList([]);
        setProductOptions([]);
        axios.get(Common.baseApiUrl + "getproducts/" + station.id + "/" + Common.currentUser.id).then(function (r) {
          if (r.data.status == 200) {
            setProductList(r.data.products.filter(function (p) {
              return p.category == 0;
            }));
            r.data.products.filter(function (p) {
              return p.category == 0;
            }).forEach(function (p) {
              setProductOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: p.label,
                  value: p.id
                }]);
              });
            });
            if (r.data.products.filter(function (p) {
              return p.category == 0;
            }).length > 0) form.setFieldsValue({
              product_id: r.data.products.filter(function (p) {
                return p.category == 0;
              })[0].id
            });
          } else {
            message.error({
              content: r.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue ' + error.toString(),
            delay: 4
          });
        })["finally"](function () {});
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 5
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      size: "large",
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "agent_id",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          style: {
            width: '240px'
          },
          options: agentOptions,
          onChange: function onChange(v) {
            var cu = agentOptions.filter(function (a) {
              return a.value == v;
            })[0];
            setProductList([]);
            setProductOptions([]);
            axios.get(Common.baseApiUrl + "getproducts/" + cu.gas_station_id + "/" + Common.currentUser.id).then(function (r) {
              if (r.data.status == 200) {
                setProductList(r.data.products.filter(function (p) {
                  return p.category == 0;
                }));
                r.data.products.filter(function (p) {
                  return p.category == 0;
                }).forEach(function (p) {
                  setProductOptions(function (prev) {
                    return [].concat(_toConsumableArray(prev), [{
                      label: p.label,
                      value: p.id
                    }]);
                  });
                });
                if (r.data.products.filter(function (p) {
                  return p.category == 0;
                }).length > 0) form.setFieldsValue({
                  product_id: r.data.products.filter(function (p) {
                    return p.category == 0;
                  })[0].id
                });
              } else {
                message.error({
                  content: r.data.message,
                  delay: 4
                });
              }
            })["catch"](function (error) {
              message.error({
                content: 'Une erreur est survenue',
                delay: 4
              });
            })["finally"](function () {});
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Produit",
        name: "product_id",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          style: {
            width: '240px'
          },
          options: productOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "indexStart",
        label: "Index depart",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "LITRES",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "indexEnd",
        label: "Index arriv\xE9",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "LITRES",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "total_cash",
        label: "Total CASH",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "total_coupon",
        label: "Total Bons",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsxs(Form.Item, {
        children: [ContextHolder, /*#__PURE__*/_jsx(Button, {
          disabled: agentOptions.length == 0 || productOptions.length == 0,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })]
      })]
    })]
  });
};
export default AddPumpReport;